import type { InterventionMenuTreeItemExtraProps } from "./intervention-menu-tree-item-extra.type";

import InterventionSectionTag from "@/modules/intervention/intervention-section-tag";

const InterventionMenuTreeItemExtra = ({
  menuItem,
}: InterventionMenuTreeItemExtraProps) => {
  const section = menuItem.data;

  return section ? <InterventionSectionTag section={section} /> : null;
};

export default InterventionMenuTreeItemExtra;
